import jwt from 'jsonwebtoken'

export async function jwtSign(param) {
  return jwt.sign(param, undefined, {
    algorithm: 'none',
  })
}

export async function jwtDecode(token) {
  return jwt.verify(token, undefined, {
    algorithms: ['none'],
  })
}
